import { gql } from '@apollo/client'

export const OPERATION_PRODUCT_ANALYTICS_KEY_FIGURES = gql`
  query ProductAnalyticsKeyFigures($period: ProductAnalyticsPeriod!, $platform: ProductAnalyticsPlatform) {
    productAnalytics(period: $period, platform: $platform) {
      period
      keyFigures {
        uniqueVisitorsPerDay
        sessionsPerDay
        medianSessionDuration
        medianSectionsPerSession
        generatedCodes
      }
    }
  }
`

export const OPERATION_PRODUCT_ANALYTICS_USAGE = gql`
  query ProductAnalyticsUsage(
    $period: ProductAnalyticsPeriod!
    $platform: ProductAnalyticsPlatform
    $withActionsByModule: Boolean!
  ) {
    productAnalytics(period: $period, platform: $platform) {
      period
      trafficBySection {
        label
        value
      }
      actionsByModule @include(if: $withActionsByModule) {
        periodStart
        codes
        users
        privateWifi
        eventWifi
        accessPointZones
        wan
        bypass
        streamCast
      }
      usageByWeekday {
        label
        value
      }
      usageByHour {
        label
        value
      }
    }
  }
`

export const OPERATION_PRODUCT_ANALYTICS_CODES = gql`
  query ProductAnalyticsCodes($period: ProductAnalyticsPeriod!, $platform: ProductAnalyticsPlatform) {
    productAnalytics(period: $period, platform: $platform) {
      period
      codeDistribution {
        channel
        actions
      }
      codeOptions {
        creations
        withOfferRate
        withPrivateWifiRate
        averageSimultaneousConnections
      }
      codeTypes {
        event
        standard
        h3
      }
      codeDisabling {
        periodStart
        disabledCodes
        generatedCodes
      }
    }
  }
`

export const OPERATION_PRODUCT_ANALYTICS_MOBILE_DEVICES = gql`
  query ProductAnalyticsMobileDevices($period: ProductAnalyticsPeriod!) {
    productAnalytics(period: $period, platform: MOBILE) {
      period
      sessionsByOs {
        label
        value
      }
      sessionsByAppVersion {
        label
        value
      }
    }
  }
`

export const OPERATION_PRODUCT_ANALYTICS_MOBILE_PRIVATE_WIFI = gql`
  query ProductAnalyticsMobilePrivateWifi($period: ProductAnalyticsPeriod!) {
    productAnalytics(period: $period, platform: MOBILE) {
      period
      privateWifiAudience {
        sessions
        sessionShare
        pageViews
      }
    }
  }
`

export const OPERATION_PRODUCT_ANALYTICS_EVENT_WIFI = gql`
  query ProductAnalyticsEventWifi($period: ProductAnalyticsPeriod!) {
    productAnalytics(period: $period) {
      period
      eventWifiAudience {
        sessions
        sessionShare
        pageViews
      }
      eventWifiActivity {
        created
        updated
        deleted
        activated
        deactivated
        passphraseReset
        passphraseGenerated
        statisticsTabOpened
        usageStatisticsOpened
      }
    }
  }
`

export const OPERATION_PRODUCT_ANALYTICS_PRIVATE_WIFI = gql`
  query ProductAnalyticsPrivateWifi($period: ProductAnalyticsPeriod!) {
    productAnalytics(period: $period) {
      period
      privateWifiActions {
        creations
        updates
        deletions
        resets
        created
        updated
        deleted
        passphraseReset
      }
      privateWifiRooms {
        created
        imported
        deleted
        reset
      }
      privateWifiImports {
        imports
        errorRows
        importsWithErrorsRate
      }
    }
  }
`

export const OPERATION_PRODUCT_ANALYTICS_STREAM_CAST = gql`
  query ProductAnalyticsStreamCast($period: ProductAnalyticsPeriod!) {
    productAnalytics(period: $period) {
      period
      streamCastAudience {
        sessions
        sessionShare
        pageViews
      }
      streamCastActivity {
        rebooted
        checkedOut
        replaced
        messages
        configStarted
        configCompleted
        configCompletionRate
        configVideoOpened
        failed
        failureRate
      }
    }
  }
`

export const OPERATION_PRODUCT_ANALYTICS_ACCESS_POINT_ZONES = gql`
  query ProductAnalyticsAccessPointZones($period: ProductAnalyticsPeriod!) {
    productAnalytics(period: $period) {
      period
      accessPointZonesAudience {
        sessions
        sessionShare
        pageViews
      }
      accessPointZonesActivity {
        deviceDisabled
        floorDisabled
        radioEnabled
        disabledDevices
        impactedStations
        disableOpened
        radioFailed
        disableAbandonmentRate
        radioFailureRate
      }
    }
  }
`
